import React, { useRef, useState, useEffect } from "react";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const UserDropdown = ({ textColor, title, onSelect, required, users }) => {
  const buttonRef = useRef(null);
  const { t, i18n } = useTranslation();
  const [selectedItem, setSelectedItem] = useState(t("select Box Number"));
  const [search, setSearch] = useState("");
  const direction = useLanguageDirection();

  useEffect(() => {
    setSelectedItem(t("select Box Number"));
  }, [i18n.language]);

  const filteredUsers = users?.filter(
    (user) =>
      user.role === "customer" &&
      user.boxNumber?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Menu as="div" className="relative inline-block w-full" dir={direction}>
      <div>
        <Menu.Button
          className={`flex md:text-base  items-center justify-between rounded-md bg-gray-100 border border-gray-300 px-2 py-3 w-full text-gray-700`}
          dir={direction}
        >
          <span className="text-xs text-gray-400 ">{selectedItem}</span>
          <ChevronDownIcon className="w-4 h-4 text-black" />
        </Menu.Button>
      </div>

      <Menu.Items className="absolute w-full bg-yellow-50 h-[35vh] overflow-y-auto rounded-lg border-t-0 border border-gray-400 ">
        <div className="sticky top-0 p-2 border-b bg-yellow-50">
          <input
            type="text"
            placeholder={t("Search")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-3 py-2 text-xs text-gray-700 bg-white border rounded-md"
          />
        </div>
        {filteredUsers?.map((user) => (
          <Menu.Item key={user._id}>
            {({ active }) => (
              <button
                onClick={() => {
                  setSelectedItem(user.boxNumber);
                  onSelect(user);
                }}
                className={`flex items-center px-4 py-2 text-sm text-start w-full ${
                  active ? "bg-gray-100 text-gray-900" : "text-gray-500"
                }`}
              >
                📦 {user?.boxNumber} — {user?.name}
              </button>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
};

export default UserDropdown;
